'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _FileInput = _interopRequireDefault(require("Components/Forms/Elements/FileInput"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _handleFileChange = _interopRequireDefault(require("Components/Forms/Functions/handleFileChange"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getStateFromObject = _interopRequireDefault(require("Components/Forms/Functions/getStateFromObject"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
class UpdatePartnerForm extends _react.Component {
  state = {
    loading: false,
    status_messages: {}
  };
  handleChange = _handleChange.default.bind(this);
  handleFileChange = _handleFileChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchPartner();
  }
  fetchPartner = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const partner_id = document.location.pathname.split('/contenu/liste-des-partenaires/modifier-partenaire/').join('');
    component.setState({
      loading: true,
      partner_id: partner_id
    });
    qwest.post('/partner/get-all', {
      id: partner_id
    }).then(function (xhr, response) {
      const logo = (response.partners[0].logo || []).map(function (data) {
        let descriptor = {
          ...data,
          status: 'uploaded',
          filename: data.url.slice(data.url.lastIndexOf('/') + 1)
        };
        return descriptor;
      });
      delete response.partners[0].logo;
      let state_update = (0, _getStateFromObject.default)({
        data: response.partners[0],
        model: 'partner'
      });
      component.setState({
        loading: false,
        ...state_update,
        'partner[logo]': logo,
        '__files-partner[logo]': logo
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  updatePartner = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const partner = (0, _getFormData.default)({
      state: state,
      pattern: 'partner['
    });
    qwest.post('/partner/update', partner).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
      window.setTimeout(function () {
        app.navigateTo((0, _Routes.URL)('PartnersDashboardPage', _Routes.front_urls));
      }, 1200);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let output = /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/partner/create"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.updatePartner
    }, "Mettre \xE0 jour", loader)), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "u-margin-bottom-30 u-margin-left-15 u-margin-right-15 u-padding-top-5 u-padding-bottom-20 u-padding-left-15 u-padding-right-15",
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['partner[name]'],
      name: "partner[name]",
      type: "text",
      label: "Nom du partenaire",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      onChange: component.handleFileChange,
      name: "partner[logo]",
      data: state,
      status: state.status_messages,
      label: "Choisissez un logo"
    })))), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.updatePartner
    }, "Mettre \xE0 jour", loader)), status);
    return output;
  }
}
exports.default = UpdatePartnerForm;
